import { useStore } from '@/store';
import { computed } from 'vue';

export const useMultiselect = () => {
  const store = useStore();

  const selectedCards = computed<any[]>(() => store.state.card.selectedCards);
  const cards = computed<any[]>(() => store.state.card.cards);
  const isAllCardsSelected = computed(() => cards.value.length === selectedCards.value.length);

  function setSelectedCards(value, card) {
    const selectedCardsIds = selectedCards.value.map(card => card._id);

    if (!value && selectedCardsIds.includes(card._id)) {
      store.dispatch(
        'setSelectedCards',
        selectedCards.value.filter(c => c._id !== card._id),
      );
    } else if (value && !selectedCardsIds.includes(card._id)) {
      store.dispatch('setSelectedCards', [...selectedCards.value, card]);
    }
  }

  function setSelectedMultipleCards(value, cardList) {
    const selectedCardsIds = new Set(selectedCards.value.map(c => c._id));

    let updatedSelectedCards;

    if (value) {
      // Add new unique cards
      updatedSelectedCards = [
        ...selectedCards.value,
        ...cardList.filter(card => !selectedCardsIds.has(card._id)),
      ];
    } else {
      // Remove cards that match the provided list
      const removeIds = new Set(cardList.map(card => card._id));
      updatedSelectedCards = selectedCards.value.filter(c => !removeIds.has(c._id));
    }

    // Dispatch the updated list once for better performance
    store.dispatch('setSelectedCards', updatedSelectedCards);
  }

  function getIsSelectedStatus(id) {
    return selectedCards.value.map(card => card._id).includes(id);
  }

  function selectAllCards(value) {
    console.log("cards.value",cards.value.length)
    const selectedCards = value ? cards.value : [];

    store.dispatch('setSelectedCards', selectedCards);
  }

  function deleteCard(card) {
    const updatedSelectedCards = selectedCards.value.filter(c => c._id !== card._id);

    // Update the selectedCards in the store
    store.dispatch('setSelectedCards', updatedSelectedCards);
  }
  function deleteManyCards(cardsToDelete) {
    const deleteIds = new Set(cardsToDelete.map(card => card._id));
    const updatedSelectedCards = selectedCards.value.filter(c => !deleteIds.has(c._id));

    // Dispatch once for better performance
    store.dispatch('setSelectedCards', updatedSelectedCards);
  }

  function resetSelectedCards() {
    store.dispatch('setSelectedCards', []);
  }

  return {
    selectedCards,
    setSelectedCards,
    getIsSelectedStatus,
    isAllCardsSelected,
    selectAllCards,
    deleteCard,
    resetSelectedCards,
    setSelectedMultipleCards,
    deleteManyCards
  };
};
